import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { User } from '../../models/user.model';

export const loggedUserActions = createActionGroup({
    source: 'Logged User',
    events: {
        'Get Logged User': props<{userId: string}>(),
        'Set Logged User': props<{data: User}>(),
        'Reset Logged User': emptyProps(),
    }
})